import ActionTypes from "../../enums/ActionTypes"

export function fetchAmountUnits() {
  return {
    type: ActionTypes.PLANNING_OBJECTS_AMOUNT_UNITS_LIST_REQUEST,
  }
}
